
import { computed, ref, onMounted, onActivated } from 'vue';
// eslint-disable-next-line
//@ts-ignore
import VueLoading from '@/components/general/Loading';
import thoughtRepository from '@/api/thoughtRepository';
import ThoughtInList from '@/components/news/ThoughtInList.vue';
import { projectStore } from '@/store/project-store';
import Paginator from 'primevue/paginator';
import { IPagerResponse } from '@/models/pager.model';
import { IThought } from '@/models/thought.model';
import Message from 'primevue/message';
import { IGenericFilter } from '@/models/filter.model';
export default {
  name: 'ThoughtInfiniteList',
  components: { ThoughtInList, VueLoading, Paginator, Message },
  props: {
    thoughtListHeight: {
      type: Number,
      default: 250,
    },
    projectid: {
      type: Number,
      required: true,
    },
  },

  setup(props: any, { emit }: any) {
    //REF
    const thoughts = ref<IThought[]>([]);
    const thoughtsLoading = ref<boolean>(true);
    const thoughtListEl = ref<HTMLElement>();
    const errorMsg = ref<IGenericFilter>({
      severity: 'info',
      content: '',
    });
    const pager = ref<IPagerResponse>({
      current_page: 1,
      entries_per_page: 10,
      total_entries: 0,
    });

    //COMPUTED
    const projectid = computed((): number | null => {
      return projectStore.getState().projectid;
    });
    const thoughtsAvailable = computed((): boolean => {
      if (thoughts.value) {
        return thoughts.value.length > 0 ? true : false;
      }
      return false;
    });

    //REF
    const fetchParams = ref<IGenericFilter>({
      sort: `-publication_date`,
      rows: 10,
      page: pager.value.current_page,
      projectid: projectid.value,
    });

    //METHODS
    function loadThoughts(pageNumber?: number, pageChange = false) {
      console.log('ThoughtInfiniteList', 'loadThoughts');
      thoughtsLoading.value = true;
      if (pageNumber) {
        fetchParams.value.page = pageNumber;
      }
      return thoughtRepository
        .get(fetchParams.value)
        .then((result: any) => {
          if (result.data) {
            thoughts.value = result.data;
            pager.value = result.pager;
            errorMsg.value.content = '';
            if (!thoughtsAvailable.value) {
              errorMsg.value.severity = 'info';
              errorMsg.value.content = 'Keine News gefunden';
            }
          } else {
            console.log('error');
            errorMsg.value.severity = 'info';
            errorMsg.value.content = 'Keine News gefunden';
          }
        })
        .then(() => {
          if (pageChange) {
            // only auto-scroll on paging
            emit('scrollIntoView');
          }
        })
        .catch(error => {
          console.log(error);
          errorMsg.value.severity = 'error';
          errorMsg.value.content = 'Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut';
        })
        .finally(() => {
          thoughtsLoading.value = false;
        });
    }
    function onPageChange(event: any) {
      loadThoughts(event.page + 1, true);
    }

    //LIFEHOOKS
    onMounted(() => {
      // Per T22188, we need to query project config here
      // because if we do it in NewsProject, the API calls for thoughts will resolve first before project config resolves
      projectStore
        .setProjectId(props.projectid, false)
        .then((proj: any) => {
          if (proj.config && 'thought_list_rows' in proj.config) {
            const rows = parseInt(proj.config.thought_list_rows);
            pager.value.entries_per_page = rows;
            fetchParams.value.rows = rows;
          }
        })
        .finally(() => {
          loadThoughts();
        });
    });
    onActivated(() => {
      emit('scrollIntoView');
    });

    return {
      //REF
      thoughts,
      errorMsg,
      //COMPUTED
      thoughtsAvailable,
      thoughtsLoading,
      onPageChange,
      pager,
      thoughtListEl,
    };
  },
};
